import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { downloadFormPdf } from '../../../../Services/adminApiService';

const PdfDownloadButton = ({ pdfDownloadUrl, formName }) => {
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState(null);

  const handleDownload = async () => {
    setDownloading(true);
    setError(null);
    try {
      const response = await downloadFormPdf(pdfDownloadUrl);

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;

      const contentDisposition = response.headers['content-disposition'];
      const filenameMatch = contentDisposition?.match(/filename="?(.+)"?/);
      link.download = filenameMatch
        ? filenameMatch[1]
        : `${formName || 'form'}.pdf`;

      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      const status = err.response?.status;
      if (status === 404) {
        setError('PDF not found.');
      } else if (status === 403) {
        setError('No permission to download.');
      } else {
        setError('Download failed.');
      }
      console.error('PDF download error:', err);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <span className="pdf-download-wrapper">
      <button
        onClick={handleDownload}
        disabled={downloading || !pdfDownloadUrl}
        className="btn-pdf-download"
      >
        {downloading ? 'Downloading...' : 'Download PDF'}
      </button>
      {error && <span className="pdf-download-error">{error}</span>}
    </span>
  );
};

PdfDownloadButton.propTypes = {
  pdfDownloadUrl: PropTypes.string,
  formName: PropTypes.string,
};

PdfDownloadButton.defaultProps = {
  pdfDownloadUrl: null,
  formName: 'form',
};

export default PdfDownloadButton;
